import React, { useEffect, useState } from "react";
import {
  Typography,
  Card,
  CardContent,
  Box,
  IconButton,
  Stack,
} from "@mui/material";
import Grid from "@mui/material/Grid2";
import DashboardLayout from "../../../layoutcontainers/DashboardLayout";
import TextContainerField from "../../../components/TextContainerField";
import { ArrowBack } from "@mui/icons-material";
import { useNavigate, useParams } from "react-router-dom";
import { fetchDataById } from "../../../api/Services";
import Spinner from "../../../components/Spinner";

const ViewGeneralCoverage = () => {
  const navigate = useNavigate();
  const params = useParams();
  const [isLoading, setIsLoading] = useState(false);
  const [coverageData, setCoverageData] = useState(null);
  

  useEffect(() => {
    const fetchData = async () => {
      const paramId = params.id;

      if (paramId) {
        setIsLoading(true);
        try {
          await fetchDataById(`/reference/general/coverage/${paramId}`).then((res) => {
            setCoverageData((prevData) => ({
              ...prevData,
              ...res?.data?.coverage,
            }));
          });
        } catch (err) {
          console.error(err);
        } finally {
            setIsLoading(false);
        }
      }
    };

    fetchData();
  }, [params.id]);

  if (isLoading) {
    return (
      <DashboardLayout>
        <Spinner />
      </DashboardLayout>
    );
  }

  return (
    <DashboardLayout>
        <Box
          sx={{
            padding: { xs: 2, md: 2 },
            bgcolor: "#f9f9f9",
            minHeight: "100vh",
          }}
        >
          <Stack
            direction="row"
            alignItems="center"
            justifyContent="left"
            spacing={1}
            mb={2}
          >
            <IconButton
              onClick={() => navigate("/general-master/general-coverage")}
            >
              <ArrowBack />
            </IconButton>
            <Typography variant="h4" gutterBottom sx={{ fontWeight: "bold" }}>
              General Coverage Information
            </Typography>
          </Stack>

          {coverageData ? (
          <Grid container spacing={3} sx={{ mx: { xs: 0, md: 2 } }}>
            <Grid xs={12} sm={6} md={4} sx={{ width: "100%" }}>
              <Card sx={{ boxShadow: 3, borderRadius: 2, bgcolor: "white" }}>
                <CardContent>
                  <Typography variant="h6" sx={{ mb: 1, fontWeight: "600" }}>
                    {coverageData?.name}
                  </Typography>
                  <TextContainerField label="IPL Coverage ID" value={coverageData?.id} labelStyle={{ fontWeight: "500" }} />
                  <TextContainerField label="Coverage Type" value={coverageData?.coverageType?.keyName} labelStyle={{ fontWeight: "500" }} />
                  <TextContainerField label="Policy Type" value={coverageData?.policyType?.keyName} labelStyle={{ fontWeight: "500" }} />
                  <TextContainerField label="Product" value={coverageData?.product?.keyName} labelStyle={{ fontWeight: "500" }} />
                  <TextContainerField label="Description" value={coverageData?.description} labelStyle={{ fontWeight: "500" }} />
                  <TextContainerField label="Auto Apply" value={coverageData?.autoApply ? "Yes" : "No"} labelStyle={{ fontWeight: "500" }} />
                  <TextContainerField label="Mandatory" value={coverageData?.mandatory ? "Yes" : "No"} labelStyle={{ fontWeight: "500" }} />
                  <TextContainerField label="Status" value={coverageData?.isActive ? "Active" : "Inactive"} labelStyle={{ fontWeight: "500" }} />
                  <TextContainerField label="Created At" value={coverageData?.createdAt} labelStyle={{ fontWeight: "500" }} />
                </CardContent>
              </Card>
            </Grid>
          </Grid>
          ) : (
            <Box>
              <Typography variant="h4" gutterBottom sx={{ textAlign: "center", fontWeight: "bold", color: "red", fontFamily: "cursive" }}>
                No Coverage Data Found
              </Typography>
            </Box>
          )}
        </Box>
    </DashboardLayout>
  );
};

export default ViewGeneralCoverage;
